import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { collection, orderBy, query } from "firebase/firestore";
import { FIRESTORE_CATEGORIES_TABLE } from "../../../constants/FirebaseConstants";

export function useCategories() {
  const firestore = useFirestore();
  const collectionRef = collection(firestore, FIRESTORE_CATEGORIES_TABLE);

  const categoriesQuery = query(
    collectionRef,
    orderBy("position", "asc"), // Sort by preferred ordering position
  );

  const { data: data, status } = useFirestoreCollectionData(categoriesQuery);
  const isLoading = status === "loading";

  return { data, isLoading };
}
